import styled from 'styled-components'

import Box from '../Box'

const SpecialTag = styled(Box).attrs({
  type: 'secondary'
})`
  position: absolute;
  z-index: 1;
  top: 12px;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 5px 12px;
  border-radius: 0px 15px 15px 0px;
  width: max-content;
  max-width: 80%;
`

export default SpecialTag
